import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import dayjs from 'dayjs';
import DateRangePicker from "../common/DateRangePicker";
import {
  Box,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  Autocomplete,
  TextField,
  IconButton,
  Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Row, Col } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import { calculateGlobalData, calculateTime } from "../common/function";
import { isDemoSavingsUser } from "../common/demoSavings";
import CarbonConsumeBarChart from "../Chart/BarCharts/CarbonConsumeBarChart";
import MoneySavedBarChart from "../Chart/BarCharts/MoneySavedBarChart";
import CarbonSavedBarChart from "../Chart/BarCharts/CarbonSavedBarChart";
import UnitConsumedIntervalLineChart from "../Chart/LineCharts/UnitConsumedIntervalLineChart";
import MoneySpentBarChart from "../Chart/BarCharts/MoneySpentBarChart";
import OnlineOfflineBarChart from "../Chart/BarCharts/OnlineOfflineBarChart";
import CurrentLineChart from "../Chart/LineCharts/CurrentLineChart";
import VoltageLineChart from "../Chart/LineCharts/VoltageLineChart";
import TemperatureLineChart from "../Chart/LineCharts/TemperatureLineChart";
import PowerConsumptionLineChart from "../Chart/LineCharts/PowerConsumptionLineChart";
import UnitSavingsDetailContainer from "../SystemValues/UnitSavings";
import VoltageDetailContainer from "../SystemValues/Voltage";
import PowerFactorDetailContainer from "../SystemValues/PowerFactor";
import ACStatusDetailContainer from "../SystemValues/ACStatus";
import OnlineStatusDetailContainer from "../SystemValues/OnlineStatus";
import ApplianceHealthDetailContainer from "../SystemValues/ApplianceHealth";
import UnitConsumedDetailContainer from "../SystemValues/UnitConsumed";
import UnitSavedDetailContainer from "../SystemValues/UnitSaved";
import MoneySavedDetailContainer from "../SystemValues/MoneySaved";
import MoneySpentDetailContainer from "../SystemValues/MoneySpent";
import CarbonSavedDetailContainer from "../SystemValues/CarbonSaved";
import MoneySavingDetailContainer from "../SystemValues/MoneySaving";
import store from "../redux";
import {
  selectedRoom as selectedRoomFromDropdown,
  selectedRoomDevices,
  selectedDeviceFromDropdown,
  selectedHouse,
} from "../redux/action/deviceDropdownSelection";
import { selectedDay, selectedEndDay } from "../redux/action/selectedDate";
import styles from "./common/styles";
import {
  fetchAndStoreMultipleDevicesTodayData,
  fetchAndStoreMulipleDevicesSelectedDayData,
} from "../redux/action/totalData";
import UnitSavedBarChart from "../Chart/BarCharts/UnitSavedBarChart";
import {
  fetchHouseDetails,
} from "../redux/action/house";
import { selectedDeviceData } from "../redux/actionTypes";
import UnitConsumedBarChart from "../Chart/BarCharts/UnitConsumedBarChart";
import PowerDetailContainer from "../SystemValues/Power";
import CurrentDetailContainer from "../SystemValues/Current";
import TemperatureDetailContainer from "../SystemValues/Temperature";
import TotalUnitsConsumedDetailContainer from "../SystemValues/TotalUnitsConsumed";
import { config } from "../../config";
import { environAwsApi, thermoAwsApi, weatherAwsApi } from "../common/ApiCall";
import WeatherControllog from "../Chart/LineCharts/WeatherControllog";
import WeattherValue from "../SystemValues/WeattherValue";
import ThermoSmartStateSystemValue from "../ThermoSmartStateSystemValue";
import SavingsDetailContainer from "../SystemValues/Saving";
import SavingBarChart from "../Chart/BarCharts/Savings";
import DoorSensor from "../SystemValues/DoorSensor";
import DoorSensorTable from "./DoorSensorTable";
import { findDatesBetween } from "../redux/action/dailyUnit";
import { notShowSystemValuesWhenMultiDay } from "./constants";
import { formatDuration, formatDurationHrsMinsSecs } from "../Settings/SettingsNavigation/Report/function";
import ApplianceOnTimeDetailContainer from "../SystemValues/ApplianceOnTimeDetailContainer";
import EnergiSychOccupancyLogs from "./EnergiSychOccupancyLogs";
import CumMoneySpentBarChart from "../Chart/BarCharts/CumMoneySpentBarChart";
import CumUnitConsumedBarChart from "../Chart/BarCharts/CumUnitConsumedBarChart";
import CumCarbonConsumeBarChart from "../Chart/BarCharts/CumCarbonConsumeBarChart";
import FrequencyLineChart from "../Chart/LineCharts/FrequencyLineChart";
import FrequencyDetailContainer from "../SystemValues/FrequencyDetailContainer";
import NetKwhKvah from "../Chart/BarCharts/NetKwhKvah";
import PowerFactorLineChart from "../Chart/LineCharts/PowerFactorLineChart";


function MainV2({ setLoading, setRoomCount, roomCount }) {
  //----------------------------------------Redux data----------------------------------------------------
  const houseData = useSelector((state) => state.houseData);
  const { houseId, selectedDeviceDetails, roomId, devices } = useSelector(
    (state) => state.dropdownSelectionData || {}
  );

  const selectedDayData = useSelector((state) => state.selectedDate);
  const selectedDate = useSelector((state) => state.selectedDate);
  const selectedEndDate = useSelector((state) => state.selectedEndDay);
  const snapshotUnit = useSelector((state) => state.snapshotUnit);
  const housesList = useSelector((state) => state.housesList);


  //----------------------------------------Use state----------------------------------------------------
  const [selectedDeviceSelectedDayData, setSelectedDeviceSelectedDayData] = useState([]); // most important variable as from this only all the data of the selected device is used
  const [systemValuesData, setSystemValuesData] = useState({
    globalMoneySaved: 0,
    globalMoneySpent: 0,
    globalUnitSaved: 0,
    globalUnitConsumed: 0,
    globalUnitSavingPercentge: 0,
    globalSaving: 0,
    globalNetUnitConsumed:0,
    globalNetMoneySpent:0,
    globalNetKwh:0,
    globalNetKvah:0,
    time: "12:00 AM",
  });

  let ppu =
    houseData.ppu !== undefined && houseData.ppu > 0 ? houseData.ppu : 15;

  const [graphData, setGraphData] = useState({
    moneySaved: [],
    moneySpent: [],
    online: [],
    carbonConsumed: [],
    carbonSaved: [],
    unitConsumed: [],
    unitSaved: [],
    saving: [],
    netUnitConsumedData: [],
  });

  const [phaseLoadLogs, setPhaseLoadLogs] = useState({});

  const [houseHasEnergySyncDevices, setHouseHasEnergySyncDevices] =
    useState(true);
  const [refreshing, setRefreshing] = useState(false);

  const handleRefresh = useCallback(async () => {
    if (!selectedDeviceDetails?.deviceId) return;
    setRefreshing(true);
    const loginDetails = store.getState().login;
    const mobileWithoutCountryCode = loginDetails.profile.mobile.slice(3);
    await fetchHouseDetails(houseId, mobileWithoutCountryCode);
    await fetchDataForDeviceAndDate(selectedDeviceDetails.deviceId, selectedDeviceDetails.type);
    setRefreshing(false);
  }, [selectedDeviceDetails, houseId]);
  useEffect(() => {
    handleDateChange([dayjs(), dayjs()])
  }, [])
  //------------------------------------useEffect for snapshot saved in redux--------------------
  useEffect(() => {

    if (Object.keys(snapshotUnit).length === 0) return;

    const selectedDeviceId = selectedDeviceDetails
      ? selectedDeviceDetails.deviceId
      : undefined;
    const dates = findDatesBetween(selectedDate, selectedEndDate);
    setSelectedDeviceSelectedDayData([]);
    let dataOfDates = [];
    for (let date of dates) {

      const selectedDateInStringWithoutHours = new Date(
        new Date(date).setHours(0, 0, 0, 0)
      ).toDateString();
      if (
        snapshotUnit[selectedDeviceId] &&
        snapshotUnit[selectedDeviceId][selectedDateInStringWithoutHours]
      ) {
        dataOfDates.push({ ...snapshotUnit[selectedDeviceId][selectedDateInStringWithoutHours], date })
      }

    }
    if (dataOfDates.length === 0) {
      fetchDataForDeviceAndDate(
        selectedDeviceDetails.deviceId,
        selectedDeviceDetails.type)
    }
    setSelectedDeviceSelectedDayData(dataOfDates)
  }, [snapshotUnit, selectedDeviceDetails]);

  //-------------------------------useEffect to calculate System Values and Graph Data---------------------------

  useEffect(() => {
    if (selectedDeviceSelectedDayData.length === 0) return;
    if (Object.keys(selectedDeviceDetails).length === 0) return;

    const { systemValues, graphData, phaseLoadLogs } = calculateGlobalData(
      selectedDeviceSelectedDayData,
      ppu,
      selectedDeviceDetails
    );
    let saving = []

    // For the demo account the saving series is derived from consumption, so it does not
    // depend on the device having a maximumUnitPerHour configured.
    if (selectedDeviceDetails?.graphParameters?.saving !== undefined && (isDemoSavingsUser() || selectedDeviceDetails?.graphParameters?.saving?.maximumUnitPerHour !== undefined)) {
      const savingDates = Object.keys(graphData.carbonConsumed)

      if (savingDates.length === 1) {
        // Single day -> one series per phase, one bar per hour slot
        saving = [...graphData.carbonConsumed[savingDates[0]]]
      } else {
        // Multiple days -> one series per phase, one bar per day
        const savingPerPhase = {}
        for (let date of savingDates) {
          for (let phaseData of graphData.carbonConsumed[date]) {
            const name = phaseData.name.split("-")[1]
            if (savingPerPhase[name] === undefined) {
              savingPerPhase[name] = { name, categories: [], totalSavingPerBarData: [] }
            }
            savingPerPhase[name].categories.push(date)
            savingPerPhase[name].totalSavingPerBarData.push(
              (phaseData.totalSavingPerBarData || []).reduce((acc, curr) => acc + (curr || 0), 0)
            )
          }
        }
        saving = Object.values(savingPerPhase)
      }
    }
    let multipleDayCarbonConsumed = []
    if (Object.keys(graphData.carbonConsumed).length > 1) {
      let multipleDayPhaseLoadLogs = {}
      for (let dataConsume in graphData.carbonConsumed) {
        for (let dataConsumed of graphData.carbonConsumed[dataConsume]) {

          let name = dataConsumed.name.split("-")[1]

          if (multipleDayPhaseLoadLogs[name] === undefined) {
            multipleDayPhaseLoadLogs[name] = [{ ...dataConsumed, name: name, date: dataConsume }]
          } else {
            multipleDayPhaseLoadLogs[name] = [...multipleDayPhaseLoadLogs[name], { ...dataConsumed, name: name, date: dataConsume }]
          }
        }
      }

      for (let dataConsume in multipleDayPhaseLoadLogs) {
        let categories = []
        let data = []
        let totalSaved = 0
        let totalSavingPer = 0
        for (let dataConsumed of multipleDayPhaseLoadLogs[dataConsume]) {
          categories.push(dataConsumed.date)
          data.push(dataConsumed.data.reduce((acc, curr) => acc + curr, 0))
          totalSaved += dataConsumed.totalSaved
          totalSavingPer += dataConsumed.totalSavingPer
        }
        multipleDayCarbonConsumed.push({ name: dataConsume, categories, data, totalSaved, totalSavingPer })
      }

    } else if (Object.keys(graphData.carbonConsumed).length === 1) {
      for (let dataConsume in graphData.carbonConsumed) {
        multipleDayCarbonConsumed = [...multipleDayCarbonConsumed, ...graphData.carbonConsumed[dataConsume]]
      }
    }
   
    // netUnitLog calculation for multiple days and single day
    let multipleDayNetUnitData = []
    if (Object.keys(graphData.netUnitConsumedData).length > 1) {
         let categories = []
        let data = []
      for (let date in graphData.netUnitConsumedData) {
     
       let graphDataNet = graphData.netUnitConsumedData[date]?.barGraphData
       console.log("graphDataNet",graphData)
          categories.push(date)
          data.push(graphDataNet?.data?.reduce((acc, curr) => acc + curr, 0))
        }
        multipleDayNetUnitData.push({ name: "Net Unit Consumed", categories, data })

    } else if (Object.keys(graphData.netUnitConsumedData).length === 1) {
      for (let date in graphData.netUnitConsumedData) {
        let graphDataNet = graphData.netUnitConsumedData[date]?.barGraphData

        multipleDayNetUnitData = [...multipleDayNetUnitData, graphDataNet]
      }
    }
   

  
    setPhaseLoadLogs({ ...phaseLoadLogs });
    setSystemValuesData({ ...systemValues });
    setGraphData({ ...graphData, carbonConsumed: multipleDayCarbonConsumed, saving,netUnitConsumedData:multipleDayNetUnitData });
  }, [selectedDeviceSelectedDayData, selectedDeviceDetails]);

  //-----------------------------------Handle Date Change-----------------------------------------
  const handleDateChange = async (newValue) => {
    store.dispatch(selectedDay(newValue[0]?.$d));
    store.dispatch(selectedEndDay(newValue[1]?.$d));
    await fetchDataForDeviceAndDate(
      selectedDeviceDetails.deviceId,
      selectedDeviceDetails.type
    );
  };

  //-----------------------------------Handle House change for house dropdown selection-------------
  const handleHouseChange = async (event) => {
    setLoading(true);
    setHouseHasEnergySyncDevices(true);
    const selectedHouseID = event.target.value;

    const loginDetails = store.getState().login;

    const mobileWithoutCountryCode = loginDetails.profile.mobile.slice(3);

    await fetchHouseDetails(selectedHouseID, mobileWithoutCountryCode);

    const houseDetails = store.getState().houseData;

    //Update default house so that next time when user logins, the last clicked device is set as default house
    // await updateDefaultHouse(selectedHouseID, mobileWithoutCountryCode)

    // const roomsWithNonEmptyEnergySync = houseDetails?.rooms?.filter(room => room.energiSync.length > 0);
    const roomsWithNonEmptyEnergySync = houseDetails?.rooms?.filter(
      (room) =>
        room.energiSync.length > 0 ||
        room.weatherSensors.length > 0 ||
        room.thermoSmarts.length > 0 ||
        room.environSyncs.length > 0
    );

    if (roomsWithNonEmptyEnergySync.length === 0) {
      setRoomCount(0);
      setLoading(false);
      setHouseHasEnergySyncDevices(false);
      store.dispatch(selectedHouse(selectedHouseID));
      store.dispatch(selectedRoomFromDropdown(""));
      store.dispatch(selectedRoomDevices([]));

      return;
    }

    setRoomCount(roomsWithNonEmptyEnergySync.length);

    const defaultRoom = roomsWithNonEmptyEnergySync[0]._id;

    const defaultRoomAllDevices = [
      ...roomsWithNonEmptyEnergySync[0].energiSync.map((e) => {
        return { ...e, type: config.deviceType.energiSync };
      }),
      ...roomsWithNonEmptyEnergySync[0].thermoSmarts.map((e) => {
        return { ...e, type: config.deviceType.thermoSmarts };
      }),
      ...roomsWithNonEmptyEnergySync[0].weatherSensors.map((e) => {
        return { ...e, type: config.deviceType.weatherSensors };
      }),
      ...roomsWithNonEmptyEnergySync[0].environSyncs.map((e) => {
        return { ...e, type: config.deviceType.environSyncs };
      }), ...roomsWithNonEmptyEnergySync[0].doorSensors.map((e) => {
        return { ...e, type: config.deviceType.doorSensors };
      })
    ];
    const defaultDeviceDetails = defaultRoomAllDevices[0];

    store.dispatch(selectedHouse(selectedHouseID));
    store.dispatch(selectedRoomFromDropdown(defaultRoom));
    store.dispatch(selectedRoomDevices(defaultRoomAllDevices));
    store.dispatch(selectedDeviceFromDropdown(defaultDeviceDetails));

    await fetchDataForDeviceAndDate(
      defaultDeviceDetails?.deviceId,
      defaultDeviceDetails?.type
    );
  };

  //-----------------------------------Handle room change for room dropdown selection-------------
  const handleRoomChange = async (event) => {
    // setLoading(true);
    const selectedRoomID = event.target.value;

    // Find the selected room from the rooms array
    const selectedRoomData = houseData?.rooms?.find(
      (room) => room._id === selectedRoomID
    );
    if (selectedRoomData) {
      const devicesData = [
        ...selectedRoomData.energiSync.map((e) => {
          return { ...e, type: config.deviceType.energiSync };
        }),
        ...selectedRoomData.thermoSmarts.map((e) => {
          return { ...e, type: config.deviceType.thermoSmarts };
        }),
        ...selectedRoomData.weatherSensors.map((e) => {
          return { ...e, type: config.deviceType.weatherSensors };
        }),
        ...selectedRoomData.environSyncs.map((e) => {
          return { ...e, type: config.deviceType.environSyncs };
        }), ...selectedRoomData.doorSensors.map((e) => {
          return { ...e, "type": config.deviceType.doorSensors }
        }),
      ];
      const defaultDeviceDetailsOfSelectedRoom = devicesData[0];
      const defaultDeviceOfSelectedRoom = devicesData[0].deviceId;
      store.dispatch(selectedRoomFromDropdown(selectedRoomID));
      store.dispatch(selectedRoomDevices(devicesData));
      store.dispatch(
        selectedDeviceFromDropdown(defaultDeviceDetailsOfSelectedRoom)
      );

      await fetchDataForDeviceAndDate(
        defaultDeviceOfSelectedRoom,
        devicesData[0].type
      );
    }
  };

  //-----------------------------------Handle device change for device dropdown selection ----------
  const handleDeviceChange = async (event) => {
    const deviceDetails = JSON.parse(event.target.value);
    store.dispatch(selectedDeviceFromDropdown(deviceDetails));
    await fetchDataForDeviceAndDate(deviceDetails.deviceId, deviceDetails.type);
  };

  //-------------------------- Common function to handle data fetching-------------------------------
  const fetchDataForDeviceAndDate = async (deviceId, type) => {
    const selectedDate = store.getState().selectedDate;
    const selectedEndDate = store.getState().selectedEndDay;
    const dates = findDatesBetween(selectedDate, selectedEndDate);
    setSelectedDeviceSelectedDayData([]);
    let dataOfDates = [];
    for (let date of dates) {
      const selectedDateInStringWithoutHours = new Date(date).setHours(
        0,
        0,
        0,
        0
      );
      const todayDateInStringWithoutHours = new Date().setHours(0, 0, 0, 0);

      const isDifferentDate =
        selectedDateInStringWithoutHours !== todayDateInStringWithoutHours;

      if (!isDifferentDate) {
        let dataToday = {}
        setLoading(true);
        if (type === config.deviceType.energiSync) {
          await fetchAndStoreMultipleDevicesTodayData([{ deviceId }]).then((res) => {
            if (res.length > 0) {
              dataToday = res[0];

            }
          });
        } else if (type === config.deviceType.environSyncs) {
          await environAwsApi(deviceId, todayDateInStringWithoutHours).then((res) => {
            if (Object.keys(res).length > 0) {
              dataToday = res;
            }
          })
        } else if (type === config.deviceType.thermoSmarts) {
          await thermoAwsApi(deviceId, todayDateInStringWithoutHours).then((res) => {
            if (Object.keys(res).length > 0) {
              dataToday = res;
            }
          })
        } else if (type === config.deviceType.weatherSensors) {
          await weatherAwsApi(deviceId, todayDateInStringWithoutHours).then((res) => {
            if (Object.keys(res).length > 0) {
              dataToday = res;
            }
          })
        }
        if (Object.keys(dataToday).length > 0) {
          dataOfDates.push({ ...dataToday, date });
        }
      } else {
        let dataPreviousDay = {}
        setLoading(true);
        if (type === config.deviceType.energiSync) {
          await fetchAndStoreMulipleDevicesSelectedDayData(
            [{ deviceId }],
            selectedDateInStringWithoutHours
          ).then((res) => {
            if (res.length > 0) {
              dataPreviousDay = res[0];
            }
          })
        } else if (type === config.deviceType.environSyncs) {
          await environAwsApi(deviceId, selectedDateInStringWithoutHours).then((res) => {
            if (Object.keys(res).length > 0) {
              dataPreviousDay = res;
            }
          })
        } else if (type === config.deviceType.thermoSmarts) {
          await thermoAwsApi(deviceId, selectedDateInStringWithoutHours).then((res) => {
            if (Object.keys(res).length > 0) {
              dataPreviousDay = res;
            }
          })
        } else if (type === config.deviceType.weatherSensors) {
          await weatherAwsApi(deviceId, selectedDateInStringWithoutHours).then((res) => {
            if (Object.keys(res).length > 0) {
              dataPreviousDay = res;
            }
          })
        }
        if (Object.keys(dataPreviousDay).length > 0) {
          dataOfDates.push({ ...dataPreviousDay, date });
        }
        // }
      }
    }
    setSelectedDeviceSelectedDayData(dataOfDates);
    setLoading(false);
  };


  //----------------------------------------------------------------------------------------------------
  const systemValuesContainerComponents = {
    temperature: (
      <TemperatureDetailContainer
        key="temperature"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    ACStatus: (
      <ACStatusDetailContainer
        key="ACStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        selectedDate={selectedDate}
        deviceId={selectedDeviceDetails?.deviceId}
      />
    ),
    applianceHealth: (
      <ApplianceHealthDetailContainer
        key="applianceHealth"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    unitConsumed: (
      <TotalUnitsConsumedDetailContainer
        key="unitConsumed"
        time={systemValuesData.time}
        unitsConsumed={systemValuesData.globalUnitConsumed}
        showTime={selectedDeviceSelectedDayData.length > 1 ? false : true}
      />
    ),
    netUnitConsumed: (
       <TotalUnitsConsumedDetailContainer
        key="netUnitConsumed"
        time={systemValuesData.time}
        unitsConsumed={systemValuesData?.globalNetUnitConsumed}
        showTime={selectedDeviceSelectedDayData.length > 1 ? false : true}
      />
    ),
    unitSaved: (
      <UnitSavedDetailContainer
        key="unitSaved"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        unitsSaved={selectedDeviceDetails?.graphParameters?.saving?.maximumUnitPerHour !== undefined ? systemValuesData.globalSaving : systemValuesData.globalUnitSaved}
      />
    ),
    moneySpent: (
      <MoneySpentDetailContainer
        key="moneySpent"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        moneySpent={systemValuesData.globalMoneySpent}
        showTime={selectedDeviceSelectedDayData.length > 1 ? false : true}
      />
    ),
    netMoneySpent: (
      <MoneySpentDetailContainer
        key="netMoneySpent"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        moneySpent={systemValuesData.globalNetMoneySpent}
        showTime={selectedDeviceSelectedDayData.length > 1 ? false : true}
      />
    ),
    moneySaved: (
      <MoneySavedDetailContainer
        key="moneySaved"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        moneySaved={systemValuesData.globalMoneySaved}
      />
    ),
    moneySaving: (
      <MoneySavingDetailContainer
        key="moneySaving"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        moneySaved={systemValuesData.globalMoneySaved}
        moneySpent={systemValuesData.globalMoneySpent}
      />
    ),
    unitSaving: (
      <UnitSavingsDetailContainer
        key="unitSaving"
        time={systemValuesData.time}
        unitsSaved={systemValuesData.globalUnitSaved}
        unitsConsumed={systemValuesData.globalUnitConsumed}
      />
    ),
    saving: (
      <SavingsDetailContainer
        key="saving"
        time={systemValuesData.time}
        unitsSaved={systemValuesData.globalSaving}
        unitsConsumed={systemValuesData.globalUnitConsumed}
      />
    ),
    carbonSaving: (
      <CarbonSavedDetailContainer
        key="carbonSaving"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        carbonSavedData={graphData.carbonSaved}
        carbonConsumedData={graphData.carbonConsumed}
      />
    ),
    applianceOnTime: (
      <ApplianceOnTimeDetailContainer
        key="applianceOnTime"
        time={selectedDeviceSelectedDayData.length > 0 ? selectedDeviceSelectedDayData[0]?.createdAt ?? systemValuesData.time : systemValuesData.time}
        value={formatDurationHrsMinsSecs(selectedDeviceSelectedDayData.length > 0 ? selectedDeviceSelectedDayData[0]?.occupiedTime || 0 : 0)}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    )
  };
  const systemValueThermoContainerComponents = {
    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    temperature: (
      <TemperatureDetailContainer
        key="temperature"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
  };
  const systemValuesWeaherContainerComponents = {

    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    temperature: (
      <TemperatureDetailContainer
        key="temperature"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    Humidity: (
      <WeattherValue
        key="Humidity"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"humidityLogs"}
        valueKey={"h"}
        name={"Humidity"}
        timeKey={"ts"}
        degree={' AH'}
      />
    ),
  };
  const systemValueEnvirnoContainerComponents = {

    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    temperature: (
      <TemperatureDetailContainer
        key="temperature"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
      />
    ),
    Humidity: (
      <WeattherValue
        key="Humidity"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"humidityLogs"}
        valueKey={"h"}
        name={"Humidity"}
        timeKey={"ts"}
        degree={' AH'}
      />
    ),
    Co2Level: (
      <WeattherValue
        key="Co2Level"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"co2Logs"}
        valueKey={"co2"}
        name={"Co2 Level"}
        timeKey={"ts"}
        toolTip={"Co2"}
        degree={" Co2"}
      />
    ),
    airQualityIndex: (
      <WeattherValue
        key="airQualityIndex"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"aqiLogs"}
        valueKey={"aqi"}
        name={"Air Quality Index"}
        timeKey={"ts"}
        toolTip={"AQI"}
        degree={" AQI"}
      />
    ),
    equivalentCarbonDioxide: (
      <WeattherValue
        key="equivalentCarbonDioxide"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"aqiLogs"}
        valueKey={"eco2"}
        name={"Equivalent CO2"}
        timeKey={"ts"}
        toolTip={"eCO2"}
        degree={" eCO2"}
      />
    ),
  };
  const systemValueDoorSensorContainerComponents = {

    onlineStatus: (
      <OnlineStatusDetailContainer
        key="onlineStatus"
        time={systemValuesData.time}
        selectedDeviceSelectedDayData={selectedDeviceDetails}
      />
    ),
    doorStatus: (
      <DoorSensor
        data={selectedDeviceDetails}
      />
    ),




  };
 
  //----------------------------------------------------------------------------------------------------------
  const chartComponents = {

    carbonSaved: (
      <CarbonSavedBarChart
        key="carbonConsumed"
        carbonSavedData={graphData.carbonSaved}
        stacked="true"
      />
    ),
     netUnitConsumed: (
      <CumUnitConsumedBarChart
        key="unitConsumed"
        carbonConsumedData={graphData.netUnitConsumedData}
        stacked="true"
      />
    ),
    carbonConsumed: (
      <CarbonConsumeBarChart
        key="carbonSaved"
        carbonConsumedData={graphData.carbonConsumed}
        stacked="true"
      />
    ),
     netCarbonConsumed: (
      <CumCarbonConsumeBarChart
        key="carbonSaved"
        carbonConsumedData={graphData?.netUnitConsumedData}
        stacked="true"
      />
    ),
    unitSaved: (
      <UnitSavedBarChart
        key="unitSaved"
        carbonSavedData={graphData.carbonSaved}
        stacked="true"
      />
    ),
    saving: (
      <SavingBarChart
        key="saving"
        carbonSavedData={graphData.saving}
        stacked="true"
      />
    ),
    unitConsumed: (
      <UnitConsumedBarChart
        key="unitConsumed"
        carbonConsumedData={graphData.carbonConsumed}
        stacked="true"
      />
    ),
   
    moneySaved: (
      <MoneySavedBarChart
        key="moneySaved"
        carbonSavedData={graphData.carbonSaved}
        ppu={ppu}
        stacked="true"
      />
    ),
    moneySpent: (
      <MoneySpentBarChart
        key="moneySpent"
        carbonConsumedData={graphData.carbonConsumed}
        ppu={ppu}
        stacked="true"
      />
    ),
    netMoneySpent: (
      <CumMoneySpentBarChart
        key="moneySpent"
        carbonConsumedData={graphData.netUnitConsumedData}
        ppu={ppu}
        stacked="true"
      />
    ),
    netKwhKvah: (
      <NetKwhKvah
        key="netKwhKvah"
        totalKwh={systemValuesData.globalNetKwh}
        totalKvah={systemValuesData.globalNetKvah}
        ppu={ppu}
        stacked="true"
      />
    ),
    temperature: (
      <TemperatureLineChart
        key="temperature"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
      />),
    onTimeTable: (
      <EnergiSychOccupancyLogs
      data={selectedDeviceDetails}
      multipleDayData={selectedDeviceSelectedDayData}
      />
    ),
    power: (
      <PowerConsumptionLineChart
        key="power"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        deviceId={selectedDeviceDetails?.deviceId}
      />
    ),
     frequency: (
      <FrequencyLineChart
        key="frequency"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        deviceId={selectedDeviceDetails?.deviceId}
      />
    ),
    powerFactor: (
      <PowerFactorLineChart
        key="powerFactor"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        deviceId={selectedDeviceDetails?.deviceId}
      />
    ),
    voltage: (
      <VoltageLineChart
        key="voltage"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        deviceId={selectedDeviceDetails?.deviceId}
        stacked="true"
      />
    ),
    current: (
      <CurrentLineChart
        key="current"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        deviceId={selectedDeviceDetails?.deviceId}
        stacked="true"
      />
    ),

  };
  const thermoChartComponent = {
    temperature: (
      <TemperatureLineChart
        key="temperature"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
      />
    ),
    controlLog: (
      <WeatherControllog
        key="control"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"controlLogs"}
        valueKey={"state"}
        name={"Control"}
        timeKey={"timestamp"}
        toolTip={"State"}
        yAxis={"Command"}
      />
    ),

  };
  const weatherChartComponent = {
    temperature: (
      <TemperatureLineChart
        key="temperature"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
      />
    ),
    Humidity: (
      <WeatherControllog
        key="Humidity"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"humidityLogs"}
        valueKey={"h"}
        name={"Humidity"}
        timeKey={"ts"}
        toolTip={"Humidity"}
        yAxis={"Absolute Humidity"}
      />
    ),
  };
  const environChartComponent = {
    temperature: (
      <TemperatureLineChart
        key="temperature"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
      />
    ),
    Humidity: (
      <WeatherControllog
        key="Humidity"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"humidityLogs"}
        valueKey={"h"}
        name={"Humidity"}
        timeKey={"ts"}
        toolTip={"Humidity"}
        yAxis={"Absolute Humidity"}
      />
    ),
    Co2Level: (
      <WeatherControllog
        key="Co2Level"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"co2Logs"}
        valueKey={"co2"}
        name={"Co2 Level"}
        timeKey={"ts"}
        toolTip={"Co2"}
        yAxis={"Co2"}
      />
    ),
    airQualityIndex: (
      <WeatherControllog
        key="airQualityIndex"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"aqiLogs"}
        valueKey={"aqi"}
        name={"Air Quality Index"}
        timeKey={"ts"}
        toolTip={"AQI"}
        yAxis={"AQI"}
      />
    ),
    equivalentCarbonDioxide: (
      <WeatherControllog
        key="equivalentCarbonDioxide"
        selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
        stacked="true"
        dataKey={"aqiLogs"}
        valueKey={"eco2"}
        name={"Equivalent carbon dioxide"}
        timeKey={"ts"}
        toolTip={"eCO2"}
        yAxis={"eCO2"}
      />
    ),
  };

  //-----------------------------------------Main---------------------------------------------------------
  return (
    <div style={{ ...styles.container }}>
      <Toaster />
      {/*-----------------------------------Dropdown Section------------------------------------------*/}

      {/*-----------------------Date Selection-------------------------*/}
      <Row
        style={{ ...styles.smallBoxContainer }}
        className="row g-4 align-items-end"
      >
        <Col md={2} sm={12}>
          {/* <Box sx={{ minWidth: 120 }}> */}

          <DateRangePicker
            startDate={selectedDate}
            endDate={selectedEndDate}
            onDateChange={handleDateChange}
          />
          {/* </Box> */}
        </Col>

        {/*-----------------------House/Property Selection-------------------------*/}
        <Col md={3} sm={12}>
          <Box sx={{ minWidth: 120 }}>
            <Box sx={{ minWidth: 120 }}>
              <Autocomplete
                id="house-select"
                options={housesList.sort((a, b) =>
                  a.houseName
                    .toLowerCase()
                    .localeCompare(b.houseName.toLowerCase())
                )}
                getOptionLabel={(option) => option.houseName || ""}
                value={housesList.find(house => house.houseAccessCode === houseId) || null}
                onChange={(event, newValue) => {
                  if (newValue) {
                    handleHouseChange({ target: { value: newValue.houseAccessCode } });
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Property"
                    placeholder="Search properties..."
                  />
                )}
                isOptionEqualToValue={(option, value) =>
                  option.houseAccessCode === value.houseAccessCode
                }
              />
            </Box>
          </Box>
        </Col>

        {/*-----------------------Room Selection-------------------------*/}
        {roomCount > 1 && (
          <Col md={3} sm={12}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="room-select-label">Room</InputLabel>
                <Select
                  labelId="room-select-label"
                  id="room-select"
                  value={roomId || ""}
                  label="Room"
                  onChange={handleRoomChange}
                >
                  {houseData?.rooms
                    ?.filter(
                      (room) =>
                        room.energiSync.length > 0 ||
                        room.weatherSensors.length > 0 ||
                        room.thermoSmarts.length > 0 ||
                        room.environSyncs.length > 0 ||
                        room.doorSensors.length > 0
                    )
                    .sort((a, b) =>
                      a.roomName.localeCompare(b.roomName, undefined, {
                        numeric: true,
                      })
                    )
                    .map((room) => (
                      <MenuItem key={room.roomName} value={room._id}>
                        {room.roomName}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          </Col>
        )}

        {/*-----------------------Device/Appliance Selection-------------------------*/}
        {houseHasEnergySyncDevices && (
          <Col md={3} sm={12}>
            <Box sx={{ minWidth: 120 }}>
              <FormControl fullWidth>
                <InputLabel id="device-select-label">Appliance</InputLabel>
                <Select
                  labelId="device-select-label"
                  id="device-select"
                  // value={selectedDeviceId}
                  value={JSON.stringify(selectedDeviceDetails)}
                  label="Appliance"
                  onChange={handleDeviceChange}
                >
                  {devices?.map((device) => {
                    if (device === null) return null;
                    return (

                      <MenuItem
                        key={device.deviceId}
                        value={JSON.stringify(device)}
                      >
                        {device?.name ? `${device?.name} - ` : ""}
                        {device.deviceId}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Box>
          </Col>
        )}

        {/*-----------------------Refresh Button-------------------------*/}
        <Col md="auto" sm={12} className="d-flex align-items-center">
          <Tooltip title="Refresh data">
            <span>
              <IconButton
                onClick={handleRefresh}
                disabled={refreshing || !selectedDeviceDetails?.deviceId}
                size="large"
                sx={{
                  border: "1px solid",
                  borderColor: "divider",
                  borderRadius: "8px",
                  p: "10px",
                }}
              >
                <RefreshIcon
                  sx={{
                    transition: "transform 0.6s ease",
                    transform: refreshing ? "rotate(360deg)" : "rotate(0deg)",
                  }}
                />
              </IconButton>
            </span>
          </Tooltip>
        </Col>

        {/*-----------------------Aliste Specific Selection-------------------------*/}
        {/* {login.userName === "aliste" && (
          <>
            <Grid item xs={8} md={2} sx={{ marginTop: "8px" }}>
              <TextField
                id="outlined-basic"
                label="Device id"
                variant="outlined"
                onChange={(e) => setDeviceId(e.target.value)}
                value={deviceId}
              />
            </Grid>
            <Grid item xs={8} md={2} sx={{ marginTop: "8px" }}>
              <Button
                variant="contained"
                size="large"
                onClick={() => {
                  if (
                    new Date(dateA).setHours(0, 0, 0, 0) !==
                    new Date().setHours(0, 0, 0, 0)
                  ) {
                    fetchAndStoreMulipleDevicesSelectedDayData([{ deviceId: deviceId }], dateA);
                    if (selectedDeviceId === "M240002") {
                      loadDataofDevice2Day("M250001", dateA);
                    }
                  } else {

                    fetchAndStoreMultipleDevicesTodayData([{ deviceId: deviceId }]);
                    if (selectedDeviceId === "M240002") {
                      loadDataofDevice2("M250001");
                    }
                  }
                }}
              >
                Get Details
              </Button>
            </Grid>
          </>
        )} */}
      </Row>

      {selectedDeviceSelectedDayData.length !== 0 &&
        houseHasEnergySyncDevices && (
          <>
            {/*----------------------------------System Values Section------------------------------------------*/}
            {/* Energy Sync */}
            {selectedDeviceDetails.type === config.deviceType.energiSync && (
              <>
{/* 
              {
                console.log(selectedDeviceDetails,"selectedDeviceDetails?.systemValues",selectedDeviceSelectedDayData.length,Object.keys(systemValuesContainerComponents).filter((value) => selectedDeviceSelectedDayData.length > 1 && !notShowSystemValuesWhenMultiDay.includes(value)))
              } */}
                <Row
                  style={{ ...styles.smallBoxContainer }}
                  className="row g-4"
                >
                  {selectedDeviceDetails?.systemValues
                    ? selectedDeviceDetails.systemValues.length > 0
                      ? selectedDeviceDetails.systemValues.filter((value) => {
                        if (selectedDeviceSelectedDayData.length > 1 && !notShowSystemValuesWhenMultiDay.includes(value)) {
                          return true
                        }
                        if (selectedDeviceSelectedDayData.length === 1) {
                          return true
                        }
                      }).map((value) => {
                        if (systemValuesContainerComponents[value]) {
                          return <Col md={3} sm={12}>{systemValuesContainerComponents[value]}</Col>
                        }
                      })
                      : null
                    : Object.keys(systemValuesContainerComponents).filter((value) => selectedDeviceSelectedDayData.length > 1 ? !notShowSystemValuesWhenMultiDay.includes(value) : true).map((key) =>
                      <Col md={3} sm={12}>{systemValuesContainerComponents[key]}</Col>
                    )}
                </Row>

                {
                  selectedDeviceSelectedDayData.length === 1 &&
                  <Row
                    style={{ ...styles.smallBoxContainer }}
                    className="row g-4 mt-0"
                  >
                    {
                      //This portion of the code is for those system value containers which can have multiple values depending upon multiple phases in that device
                      Object.keys(phaseLoadLogs).length !== 0 &&
                      phaseLoadLogs[selectedDeviceDetails.deviceId] &&
                      Object.keys(phaseLoadLogs[selectedDeviceDetails.deviceId]).map(
                        (phase) => {
                          const { data = [], unit } =
                            phaseLoadLogs[selectedDeviceDetails.deviceId][phase] || {};
                          const systemValues =
                            selectedDeviceDetails.systemValues || [];
                          const components = {
                            voltage: VoltageDetailContainer,
                            frequency: FrequencyDetailContainer,
                            current: CurrentDetailContainer,
                            powerFactor: PowerFactorDetailContainer,
                            power: PowerDetailContainer,
                          };
                          return (
                            <React.Fragment key={`${selectedDeviceDetails.deviceId}-${phase}`}>
                              {systemValues.map((value) => {
                                const Component = components[value];
                                return Component ? (
                                  <Col md={3} sm={12} key={`${phase}-${value}`}>
                                    <Component
                                      key={`${phase}-${value}`}
                                      phaseLoadLogs={phaseLoadLogs}
                                      phaseWiseData={data}
                                      phase={phase}
                                      deviceId={selectedDeviceDetails.deviceId}
                                      multipleDaysLogs={selectedDeviceSelectedDayData}
                                    />
                                  </Col>
                                ) : null;
                              })}
                              {Object.keys(phaseLoadLogs[selectedDeviceDetails.deviceId])
                                .length > 1 && systemValues.includes("unitConsumed") && (
                                  <Col md={3} sm={12}>
                                    <UnitConsumedDetailContainer
                                      phaseLoadLogs={phaseLoadLogs}
                                      phaseWiseData={data}
                                      phase={phase}
                                      key={`${phase}-unit consumed`}
                                      deviceId={selectedDeviceDetails.deviceId}
                                      unit={unit}
                                      multipleDaysLogs={selectedDeviceSelectedDayData}
                                    />
                                  </Col>
                                )}
                            </React.Fragment>
                          );
                        }
                      )
                    }
                  </Row>
                }

              </>
            )}
            {/* Thermo Chart */}
            {selectedDeviceDetails.type === config.deviceType.thermoSmarts && (
              <>
                <Row style={{ ...styles.smallBoxContainer }}>
                  {Object.keys(systemValueThermoContainerComponents).map((key) =>
                    <Col md={3} sm={12}>{systemValueThermoContainerComponents[key]}</Col>
                  )}
                </Row>
                <Row style={{ ...styles.smallBoxContainer }}>

                  <ThermoSmartStateSystemValue
                    key="control"
                    time={systemValuesData.time}
                    selectedDeviceSelectedDayData={selectedDeviceSelectedDayData}
                    dataKey={"controlLogs"}
                    valueKey={"state"}
                    name={"Control"}
                  />

                </Row>
              </>
            )}


            {/* Weather Chart */}
            {selectedDeviceDetails.type === config.deviceType.weatherSensors && (
              <Row style={{ ...styles.smallBoxContainer }} className="row g-4">
                {Object.keys(systemValuesWeaherContainerComponents).map((key) =>
                  <Col md={3} sm={12}>{systemValuesWeaherContainerComponents[key]}</Col>
                )}
              </Row>
            )}

            {/* Environ Chart */}
            {selectedDeviceDetails.type === config.deviceType.environSyncs && (
              <Row style={{ ...styles.smallBoxContainer }} className="row g-4">
                {Object.keys(systemValueEnvirnoContainerComponents).map((key) =>
                  <Col md={3} sm={12}>{systemValueEnvirnoContainerComponents[key]}</Col>
                )}
              </Row>
            )}
            {
              selectedDeviceDetails.type !== config.deviceType.doorSensors &&
              <>
                {/*-----------------------------------Charts Section------------------------------------------*/}
                {/* Energy Sync */}
                {selectedDeviceDetails.type === config.deviceType.energiSync && (
                  <Row style={{ marginBottom: "20px" }}>
                    {selectedDeviceDetails?.graphParameters
                      ? Object.keys(selectedDeviceDetails.graphParameters).length >
                        0
                        ? Object.keys(chartComponents).map((key) =>
                          selectedDeviceDetails.graphParameters.hasOwnProperty(
                            key
                          ) ? (
                            <Col key={key} md={6} sm={12}>
                              <div style={{ ...styles.chartContainer }} key={key}>
                                {chartComponents[key]}
                              </div>
                            </Col>
                          ) : null
                        )
                        : null
                      : Object.keys(chartComponents).map((key) => (
                        <Col key={key} md={6} sm={12}>
                          <div style={{ ...styles.chartContainer }} key={key}>
                            {chartComponents[key]}
                          </div>
                        </Col>
                      ))}
                  </Row>
                )}

                {/* Thermo Chart */}
                {selectedDeviceDetails.type === config.deviceType.thermoSmarts && (
                  <Row style={{ marginBottom: "20px" }}>
                    {Object.keys(thermoChartComponent).map((key) => (
                      <Col key={key} md={6} sm={12}>
                        <div style={{ ...styles.chartContainer }}>
                          {thermoChartComponent[key]}
                        </div>
                      </Col>
                    ))}
                  </Row>
                )}

                {/* Weather Chart */}
                {selectedDeviceDetails.type ===
                  config.deviceType.weatherSensors && (
                    <Row style={{ marginBottom: "20px" }}>
                      {Object.keys(weatherChartComponent).map((key) => (
                        <Col key={key} md={6} sm={12}>
                          <div style={{ ...styles.chartContainer }}>
                            {weatherChartComponent[key]}
                          </div>
                        </Col>
                      ))}
                    </Row>
                  )}

                {/* Environ Syncs Chart */}
                {selectedDeviceDetails.type === config.deviceType.environSyncs && (
                  <Row style={{ marginBottom: "20px" }}>
                    {Object.keys(environChartComponent).map((key) => (
                      <Col key={key} md={6} sm={12}>
                        <div style={{ ...styles.chartContainer }}>
                          {environChartComponent[key]}
                        </div>
                      </Col>
                    ))}
                  </Row>
                )}
              </>
            }
          </>
        )
      }

      {/* Door Sensor */}
      <>
        {/* Door Sensor System Value */}
        {selectedDeviceDetails.type === config.deviceType.doorSensors && (
          <Row style={{ ...styles.smallBoxContainer }} className="row g-4">
            {Object.keys(systemValueDoorSensorContainerComponents).map((key) =>
              <Col md={3} sm={12} key={key}>{systemValueDoorSensorContainerComponents[key]}</Col>
            )}
          </Row>
        )}
        {
          selectedDeviceDetails?.type === config?.deviceType?.doorSensors && <DoorSensorTable data={selectedDeviceDetails} selectedDate={selectedDate} selectedEndDate={selectedEndDate} />
        }
      </>
    </div >
  );
}

export default MainV2;
